import React, { useEffect, useState } from 'react';
import "./Edit.css";
import { useParams, useLocation } from "react-router-dom";
import { useTreeView } from "../../context/treeViewContext";
import { useEditState } from "../../context/EditStateContext";

// タブコンポーネントの読み込み
import Tab01 from "./tab01/tab01";
import Tab02 from "./tab02/tab02";
import Tab03 from "./tab03/tab03";
import Tab04 from "./tab04/tab04";
import Tab05 from "./tab05/tab05";
import Tab06 from "./tab06/tab06";

// モーダル（例：ユーティリティ仕様の電気設定）
import ModalElectric from "./tab01/modalElectric/modalElectric";

const TabComponent = () => {
    const [isEditing, setIsEditing] = useState(false);
    const { setIsEditing: setGlobalEditing } = useEditState();
    const [isTabEditing, setTabIsEditing] = useState(false);
    const [canEdit, setCanEdit] = useState({
        electric: false,
        air: false,
        water: false,
        network: false
      });
    // タブの設定
    const tabs = [
        { id: "01", label: "原動仕様", component: <Tab01 canEdit={canEdit} setCanEdit={setCanEdit} /> },
        { id: "02", label: "日程", component: <Tab02 canEdit={canEdit} isEditing={isEditing} setIsEditing={setIsEditing}/> },
        { id: "03", label: "マスター情報", component: <Tab03 onEditingChange={setIsEditing} isEditing={isEditing}/> },
        // { id: "04", label: "メンバー登録", component: <Tab04 /> },
        { id: "05", label: "ファイル保存", component: <Tab05 /> },
        { id: "06", label: "変更履歴", component: <Tab06 /> },
    ];
    const location = useLocation();
    const { state } = location;
    const { masterID } = useParams(); // URLのmasterIDを取得

    const { deviceNameMap, setDeviceNameMap } = useTreeView(); // コンテキストからデバイス名マップを取得
    const [isElectricModalOpen, setElectricModalOpen] = useState(false);

    
    useEffect(() => {
        setGlobalEditing(isEditing); // 編集状態が変わるたびに反映
    }, [isEditing, setGlobalEditing]);

    // アクティブなタブ状態を管理（初期値はstate→localStorage→"01"の順に参照）
    const [activeTabForEdit, setActiveTabForEdit] = useState(() => {
        return state?.initialTab || localStorage.getItem("activeTabForEdit") || "01";
    });

    // タブが切り替わったらlocalStorageにも保存
    useEffect(() => {
        localStorage.setItem("activeTabForEdit", activeTabForEdit);
    }, [activeTabForEdit]);

    // モーダルを開く条件をチェック（state経由で画面遷移してきた場合）
    useEffect(() => {
        if (state?.openModal && state?.data?.colorClass === "electric") {
        setElectricModalOpen(true);
        }
    }, [state]);

    useEffect(() => {
        console.log("✅ edit.js で受け取った canEdit:", canEdit);
      }, [canEdit]);

    

    return (
        <>
        <h1>マスター編集画面</h1>
        <h2>ID : {masterID}　名称：{deviceNameMap[masterID]}</h2>
        <div className="tab">
            {/* タブメニュー */}
            <ul className="tab__menu">
        {tabs.map((tab) => {
        const isDisabled = isEditing && tab.id !== activeTabForEdit;
        return (
            <li
            key={tab.id}
            className={`tab__menu-item ${activeTabForEdit === tab.id ? "is-active" : ""} ${isDisabled ? "is-disabled" : ""}`}
            data-tab={tab.id}
            disabled={isDisabled}
            onClick={() => {
                if (!isDisabled) {
                    setActiveTabForEdit(tab.id);
                }
              }}
            >
              {tab.label}
            </li>
          );
        })}
      </ul>

            {/* タブコンテンツ */}
            <div className="tab__panel">
            {tabs.map((tab) => (
                <div
                key={tab.id}
                className={`tab__panel-box tab__panel-box0${tab.id} ${activeTabForEdit === tab.id ? "is-show" : ""}`}
                data-panel={tab.id}
                >
                {tab.component}
                </div>
            ))}
            </div>
        </div>
        </>
    );
};

export default TabComponent;
